<template>
    <div>
        <div class="d-flex bg-greige p-1 mb-1">
            <p :class="pictoClass">
                <span class="icon-rewards me-1 font-size-32" />
            </p>
            <div class="row">
                <div v-if="promoTitle && promoSubtitle" class="col-auto ps-1">
                    <p class="d-flex flex-column mb-0">
                        <span class="font-size-16 fw-bold">{{ promoTitle }}</span>
                        <span class="font-size-16">{{ promoSubtitle }}</span>
                    </p>
                </div>
                <div v-if="odrTitle && odrSubtitle" class="col-auto ps-1">
                    <p class="d-flex flex-column mb-0">
                        <span class="font-size-16 fw-bold">{{ odrTitle }}</span>
                        <span class="font-size-16">{{ odrSubtitle }}</span>
                    </p>
                </div>
                <div class="col-auto ms-sm-auto me-2 mt-auto text-sm-end ps-1 pt-0">
                    <ob1-liens
                        :text="linkLabel"
                        is-button
                        :is-dark-link="withDarkLink"
                        with-arrow
                        :modal-id="modalId"
                        @ob1-liens-click="$emit('promo-odr-click')"
                    />
                </div>
                <slot />
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        promoAmountInCents: {
            type: Number,
            required: false,
            default: undefined
        },
        promoEndDate: {
            type: String,
            required: false,
            default: undefined
        },
        odrAmountInCents: {
            type: Number,
            required: false,
            default: undefined
        },
        odrStartDate: {
            type: String,
            required: false,
            default: undefined
        },
        odrEndDate: {
            type: String,
            required: false,
            default: undefined
        },
        bundlePackName: {
            type: String,
            required: false,
            default: undefined
        },
        promoOdrMessages: {
            type: Object,
            required: true
        },
        modalId: {
            type: String,
            required: true
        },
        hidePictoBellowSmallFormat: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        promoTitle() {
            if (this.bundlePackName && this.promoAmountInCents) {
                return this.promoOdrMessages.bundlePromoTitle
                    .replace("{0}", PriceFormatter.formatEurosWithSpace(this.promoAmountInCents / 100, false).toString())
                    .replace("{1}", this.bundlePackName)
            }
            if (this.promoAmountInCents) {
                return this.promoOdrMessages.promoTitle.replace("{0}", PriceFormatter.formatEurosWithSpace(this.promoAmountInCents / 100, false).toString())
            }
            return undefined
        },
        promoSubtitle() {
            if (this.promoEndDate) {
                return this.promoOdrMessages.promoSubtitle.replace("{0}", this.promoEndDate)
            }
            return undefined
        },
        odrTitle() {
            if (this.odrAmountInCents) {
                return this.promoOdrMessages.odrTitle.replace("{0}", PriceFormatter.formatEurosWithSpace(this.odrAmountInCents / 100, false).toString())
            }
            return undefined
        },
        odrSubtitle() {
            if (this.odrStartDate && this.odrEndDate) {
                return this.promoOdrMessages.odrSubtitle
                    .replace("{0}", this.odrStartDate)
                    .replace("{1}", this.odrEndDate)
            }
            return undefined
        },
        pictoClass() {
            if (this.hidePictoBellowSmallFormat) {
                return "hide-picto"
            }
            return ""
        },
        withDarkLink() {
            // sur Orange comme le background est de couleur greige, le lien chevron doit être noir pour l'accessibilité
            // sur Sosh comme le background est de couleur gris2, le lien chevron reste normal
            const ob1SoshPage = document.querySelector(".ob1-sosh")
            return !ob1SoshPage
        },
        linkLabel() {
            return this.promoOdrMessages.linkLabel
        }
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.font-size-32 {
    font-size: px-to-rem(32);
}

.hide-picto {
    @media(max-width: #{map-get($grid-breakpoints, sm)}) {
        display: none;
    }
}
</style>
